import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common/index.js'
import user from './modules/user/index.js'
import dict from './modules/common/dict.js'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common: common,
    user: user,
    dict: dict
  },
  getters
  /* state,
  actions,
  mutations */
})



// WEBPACK FOOTER //
// ./src/store/index.js